<template>
    <div v-loading="dataLoading">
        <el-form
            :model="formData"
            :rules="rules"
            ref="formData"
            label-position="top"
            size="medium"
        >
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="title" label="商品名称:">
                        <el-input
                            v-model="formData.title"
                            placeholder="请填写商品名称"
                            :maxlength="40"
                        ></el-input>
                    </el-form-item>
                    <el-form-item prop="subTitle" label="商品副标题:">
                        <el-input
                            v-model="formData.subTitle"
                            placeholder="请填写商品副标题"
                            :maxlength="100"
                        ></el-input>
                    </el-form-item>
                    <el-form-item prop="redeemPoint" label="商品兑换积分:">
                        <el-input-number v-model="formData.redeemPoint" :min="1" :max="99999" :precision="0" style="width:100%"></el-input-number>
                    </el-form-item>
                    <el-form-item :prop="formData.stockType == 1 ? 'stock' : 'stockType'" label="库存:" :show-message="formData.stockType == 1 ? true : false">
                        <el-radio-group v-model="formData.stockType">
                            <el-radio :label="1" border>设置库存</el-radio>
                            <el-radio :label="2" border>无库存上限</el-radio>
                        </el-radio-group>
                        <div v-if="formData.stockType == 1" class="MT20">
                            <el-input-number v-model="formData.stock" :min="1" :max="99999" :precision="0" style="width:100%"></el-input-number>
                        </div>
                    </el-form-item>
                    <el-form-item :prop="formData.coverType == 0 ? 'coverImage' : 'coverType'" label="商品封面:" :show-message="formData.coverType == 0 ? true : false">
                        <el-radio-group v-model="formData.coverType" :disabled="categoryName == '优惠券' ? true : false">
                            <el-radio :label="1" border>使用模板图</el-radio>
                            <el-radio :label="0" border :disabled="categoryName != '优惠券'">自定义上传</el-radio>
                        </el-radio-group>
                        <div v-if="formData.coverType == 0" class="MT20">
                            <image-upload 
                                :url.sync="formData.coverImage" 
                                :urlFull.sync="formData.coverImage" 
                                @onSuccess="handleImageSuccess"
                            >
                            </image-upload>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="categoryId" label="商品分类:">
                        <el-select v-model="formData.categoryId" placeholder="请选择">
                            <el-option v-for="(item,index) in goodsCategory" :key="index" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="categoryName == '纪念票'" prop="objectId" label="商品ID:">
                        <el-input
                            v-model="formData.objectId"
                            placeholder="请输入要绑定纪念票商品ID"
                            :disabled="formData.id ? true : false"
                        ></el-input>
                    </el-form-item>
					<el-form-item v-if="categoryName == '赠票'" prop="objectId" label="赠票ID:">
					    <el-input
					        v-model="formData.objectId"
					        placeholder="请输入要绑定赠票ID"
					        :disabled="formData.id ? true : false"
					    ></el-input>
					</el-form-item>
					<el-form-item v-if="categoryName == '商品'" prop="objectId" label="商品ID:">
					    <el-input
					        v-model="formData.objectId"
					        placeholder="请输入要绑定商品ID"
					        :disabled="formData.id ? true : false"
					    ></el-input>
					</el-form-item>
					<el-form-item v-if="categoryName == '优惠券'" prop="objectId" label="优惠券ID:">
					    <el-input
					        v-model="formData.objectId"
					        placeholder="请填写优惠券ID"
					        :disabled="formData.id ? true : false"
					    ></el-input>
					</el-form-item>
					<el-form-item v-if="categoryName == '抽奖'" prop="objectId" label="抽奖活动ID:">
					    <el-input
					        v-model="formData.objectId"
					        placeholder="请填写抽奖活动ID"
					        :disabled="formData.id ? true : false"
					    ></el-input>
					</el-form-item>
                    <el-form-item prop="datetimerange" label="兑换时间:">
                        <el-date-picker
                            v-model="formData.datetimerange"
                            type="datetimerange"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            unlink-panels
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item prop="illustrate" >
                        <span slot="label">兑换说明: <small>将在兑换详情页展示</small></span>
                        <el-input type="textarea" v-model="formData.illustrate" :maxlength="500" show-word-limit :rows="6" resize="none"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="page-btns-box MT20">
            <el-button @click="goBack">返 回</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">提 交</el-button>
        </div>
    </div>
</template>

<script>
import ImageUpload from '@/components/ImageUpload';
import {fetchPointsGoodsCategory} from '@/assets/js/commonApi.js'
const defaultFormData = {
    title: "",
    datetimerange: null,
    redeemStartTime: null,
    redeemEndTime: null,
    categoryId: "",
    objectId: "",
    redeemPoint: "",
    stock: undefined,
    stockType: 1,
    illustrate: "",
    subTitle: "",
    coverImage: "",
    coverType: 1
}
export default {
    props:{
        id: {
            type: [Number, String],
            default: ""
        }
    },
    components:{ImageUpload},
    data(){
        const valiId = async (rule, val, callback) => {
            await this.checkId(val).then((res) => {
                callback()
            }).catch((msg) => {
                callback(new Error(msg));
            })
        }
        return{
            formData: {
                ...defaultFormData
            },
            dataLoading: false,
            btnLoading: false,
            rules: {
                title: [{ required: true, message: "请填写商品名称" }],
                categoryId: [{ required: true, message: "请选择商品分类" }],
                objectId: [{ required: true, message: "请填写需要绑定的ID" }],
                redeemPoint: [{ required: true, message: "请填写商品兑换积分" }],
                stock: [{ required: true, message: "请填写商品库存" }],
                datetimerange: [{ required: true, message: "请填写兑换时间" }],
                illustrate: [{ required: true, message: "请填写兑换说明" }],
                coverImage: [{ required: true, message: "请上传商品封面" }],
            },
            goodsCategory: [],
            reFresh: false,
            redirect: this.$route.query.redirect || '/operation/pointsGoods/list',
            categoryName: "",
            couponList: []
        }
    },
    watch:{
        'formData.categoryId'(id) {
            const category = this.goodsCategory.find(v => v.id == id);
            this.categoryName = category ? category.name : "";
            if( this.categoryName == '优惠券' ){
                this.formData.coverType = 1
            }
        }
    },
    mounted(){
        this.getGoodsCategory();
    },
    methods: {
        //检验id有效性
        checkId(value){
            return new Promise((resolve,reject) => {
                if( this.categoryName == '优惠券' ){
                    this.$request({
                        url: "/lottery/prize/parsingCouponRule",
                        params: {
                            couponRuleId: value,
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg, result } = res.data;
                            if (state == 1 && result && result.length > 0) {
                                this.couponList = result
                                resolve( true );
                            } else {
                                this.couponList = []
                                // callback(new Error(msg || 'ID无效，请重新输入!'));
                                reject(msg || 'ID无效，请重新输入!')
                            }
                        })
                        .catch(() => {
                            this.couponList = []
                            // callback(new Error('查询失败,请重试!'));
                            reject('查询失败,请重试!')
                        })
                }else{
                    this.couponList = []
                    resolve(true)
                }
            })
            
        },
        // 获取所有积分商品类型
        getGoodsCategory(){
            this.dataLoading = true;
            fetchPointsGoodsCategory().then((res) => {
                const { state, msg, result } = res.data;
                if ( state == 1 && result) {
					this.goodsCategory = result || [];
                    if( this.id ){
                        this.getDetailData();
                    }else{
                        this.formData = {
                            ...defaultFormData,
                            categoryId: result.length > 0 ? result[0].id : ''
                        }
                        this.reFresh = true;
                        this.dataLoading = false;
                    }
				} else {
					this.$message.error(msg || "获取商品分类失败");
                    this.dataLoading = false;
				}
            }).catch(() => {
				this.$message.error("获取商品分类失败");
                this.dataLoading = false;
			})
        },
        // 获取详情
        getDetailData(){
            this.$request({
                url: "/point/goods/detail",
                method: "POST",
                params: {
                    id: this.id
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.formData = {
                        ...defaultFormData,
                        ...result,
                        datetimerange: result.redeemStartTime ? [result.redeemStartTime,result.redeemEndTime] : [],
                    };
                    if( result.stock == -1 ){
                        this.formData.stockType = 2
                    }
                    this.reFresh = true;
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.dataLoading = false;
			});
        },
        //图片上传成功后执行 需要重置海报的水印图
        handleImageSuccess(){
            if(this.formData.coverImage){
                this.$refs["formData"].clearValidate('coverImage');
            }
        },
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
        //表单提交
        submitForm(){
            this.$refs["formData"].validate( async (valid) => {
                if (valid) {
                    this.btnLoading = true;

                    this.$request({
                        url: '/point/goods/save',
                        data: {
                            ...this.formData,
                            redeemStartTime: this.formData.datetimerange[0],
                            redeemEndTime: this.formData.datetimerange[1],
                            stock: this.formData.stockType == 2 ? -1 : this.formData.stock,
                            // coverImage: this.formData.coverType == 0 ? this.formData.coverImage : ""
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.goBack();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },
    }
}
</script>

<style lang="scss" scoped>

</style>